const API_URL = "https://quizapi.io/api/v1/questions";
const API_KEY = "B27jnk1wmfEOQ42FtmrgBogiNTLLhOArJj29y24a";

const API =
  process.env.NODE_ENV === "production"
    ? "https://exams.loonlog.ca/api/questions"
    : "http://localhost:5010/api/questions";

export const fetchQuestions = async (subject, chapter) => {
  // const response = await fetch(`${ API_URL }?apiKey=${ API_KEY }&subject=${ subject }&chapter=${ chapter }&limit=10`);
  const response = await fetch(
    `${API}?subject=${subject}&chapter=${chapter}&limit=10`
  );
  const questions = await response.json();

  return questions;
};
